<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <strong>AAM - Add New Type</strong>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="type"
                :rules="typeRules"
                label="Type"
                color="red darken1"
                required
              ></v-text-field>
              <v-text-field
                v-model="typeDesc"
                :rules="typeDescRules"
                label="Type Desc"
                color="red darken1"
                required
              ></v-text-field>
              <v-row>
                <!-- START DATE -->
                <v-col v-if="!isEdit" cols="6">
                  <v-menu
                    v-model="isShowStartDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="red darken1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      @input="isShowStartDate = false"
                      color="red darken1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- END DATE -->
                <v-col cols="6">
                  <v-menu
                    v-model="isShowEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="endDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="red darken1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      @input="isShowEndDate = false"
                      color="red darken1"
                    >
                      <template>
                        <v-card-actions class="w-100 float-right">
                          <v-btn
                            small
                            flat
                            color="warning"
                            @click="
                              (endDate = new Date().toISOString().substr(0, 10)),
                                (isShowEndDate = false)
                            "
                            >Select Today</v-btn
                          >
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-btn @click="confirmModal(submit)" color="warning" class="mr-4"
                >Submit</v-btn
              >
            </v-form>
          </v-card>

          <br />
          <v-card class="pa-5">
            <v-card-title>
              Type List
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchType"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                color="red darken1"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="dtHeaders"
              :items="dtItems"
              :search="searchType"
              :loading="dtLoading"
              loading-text="Fetching Data..."
            >
              <template v-slot:item.edit="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.typeId)"
                  >mdi-pencil</v-icon
                >
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will save input data to database. Please give confirmation before you
          continue.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";

const dtHeaders = [
  { text: "Type", value: "typeCode" },
  { text: "Type Desc", value: "typeDesc" },
  { text: "Start Date", value: "startDate" },
  { text: "End Date", value: "endDate" },
  { text: "Edit", value: "edit", sortable: false },
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      methodAction: "",
      isOpenModalConfirm: false,
      isEdit: false,
      type: "",
      typeRules: [(v) => !!v || "Type is required"],
      typeDesc: "",
      typeDescRules: [(v) => !!v || "Type description is required"],
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      isShowStartDate: false,
      endDate: moment("4001-12-31").endOf("month").format("YYYY-MM-DD"),
      isShowEndDate: false,
      isLoading: false,
      snackbarText: "",
      isShowSnackbar: false,
      valid: true,
      dtHeaders,
      searchType: "",
      dtItems: [],
      dtLoading: false,
    };
  },
  mounted() {
    this.populateDataTable();
    if (this.$route.params.typeId) {
      this.getStructureTypeById(this.$route.params.typeId);
    }
  },
  watch: {
    $route(to) {
      if (to.params.typeId) {
        this.getStructureTypeById(to.params.typeId);
      }
    },
  },
  methods: {
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    submit() {
      const isValid = this.$refs.form.validate();
      if (isValid == false) return;
      this.isLoading = true;
      this.isOpenModalConfirm = false;
      const userData = JSON.parse(localStorage.getItem("userData"));
      let data = {
        typeCode: this.type,
        typeDesc: this.typeDesc,
        startDate: this.startDate,
        endDate: this.endDate,
        userIdUpdate: userData.USER_ID,
        lastUpdate: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      //PROCEED TO EDIT
      if (this.$route.params.typeId) {
        data.typeId = this.$route.params.typeId;
        this.editStructureType(data);
        return;
      }

      this.$http
        .post("/structure/type/insert", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          if (res.data.success) {
            this.isLoading = false;
            this.showSnackbar(res.data.data);
            this.type = "";
            this.typeDesc = "";
            this.$refs.form.resetValidation();
            this.populateDataTable();
          } else {
            this.isLoading = false;
            this.showSnackbar(res.data.data);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    populateDataTable() {
      this.dtLoading = true;
      this.$http
        .get("/structure/type/select", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          this.dtLoading = false;
          let { data } = res.data;
          this.dtItems = data.map((obj) => {
            return {
              typeId: obj.EMPLOYEE_TYPE_ID,
              typeCode: obj.EMPLOYEE_TYPE_CODE,
              typeDesc: obj.EMPLOYEE_TYPE_DESC,
              startDate: moment(obj.EMPLOYEE_TYPE_START_DATE).format("YYYY-MM-DD"),
              endDate: moment(obj.EMPLOYEE_TYPE_END_DATE).format("YYYY-MM-DD"),
            };
          });
        })
        .catch((err) => {
          this.dtLoading = false;
          console.log("error datatable", err.toString());
        });
    },
    editItem(typeId) {
      this.$router.push({ path: `/structure/type/${typeId}` });
    },
    getStructureTypeById(id) {
      window.scrollTo(0, 0);
      this.isLoading = true;
      this.$http
        .get(`/structure/type/${id}`, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          this.isLoading = false;
          const { data } = res.data;
          this.type = data[0].EMPLOYEE_TYPE_CODE;
          this.typeDesc = data[0].EMPLOYEE_TYPE_DESC;
          this.startDate = moment(data[0].EMPLOYEE_TYPE_START_DATE).format("YYYY-MM-DD");
          this.endDate = moment(data[0].EMPLOYEE_TYPE_END_DATE).format("YYYY-MM-DD");
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("error getStructureTypeById", err.toString());
        });
    },
    editStructureType(data) {
      this.$http
        .post("/structure/type/update", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          console.log(res);
          if (res.data.success) {
            this.isLoading = false;
            this.showSnackbar("Edit Success");
            this.type = "";
            this.typeDesc = "";
            this.$refs.form.resetValidation();
            this.populateDataTable();
            this.$router.push({ name: "Type" });
          } else {
            this.isLoading = false;
            this.showSnackbar(res.data.message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
  },
};
</script>
